import { useMutation } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const createObservationForm = async (data: Partial<IAdminObservationForm>) => {
	const url = "/observations/admin/forms/";
	const response = await cmsClient.post<IAdminObservationForm>(url, data);

	return response.data;
};

const useCreateObservationForm = () => {
	const mutation = useMutation(createObservationForm);

	return mutation;
};

export default useCreateObservationForm;
